import {handleActions, combineActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {DEFAULT_COLOR_ID} from "../../workflowStatus/constants";
import {NEW_STATUS_COLOR_ID, NEW_STATUS_ID} from "./constants";

const initialState = {
    firstLoading: true,
    statuses: [],
    statusesInUseIds: [],
    loading: false,
    editingStatus: {
        id: null,
        name: '',
        type: '',
        position: -1,
        colorId: DEFAULT_COLOR_ID
    },
    showEditStatusDialog: false,
    errors: []
}

export default handleActions({
    [ActionTypes.LOAD_DATA]: (state) => ({
        ...state,
        firstLoading: true,
    }),
    [ActionTypes.LOAD_DATA_SUCCESS]: (state, {payload: statusesInUseIds}) => ({
        ...state,
        statusesInUseIds,
        errors: [],
        firstLoading: false,
    }),
    [ActionTypes.LOAD_DATA_FAILURE]: (state, {payload: errors}) => ({
        ...state,
        errors,
        firstLoading: false,
    }),
    [combineActions(
        ActionTypes.CREATE_NEW_STATUS, ActionTypes.EDIT_STATUS, ActionTypes.DELETE_STATUS, ActionTypes.CHANGE_STATUS_POSITION,
    )]: (state) => ({
        ...state,
        loading: true,
    }),
    [combineActions(
        ActionTypes.CREATE_NEW_STATUS_SUCCESS,
        ActionTypes.EDIT_STATUS_SUCCESS,
        ActionTypes.DELETE_STATUS_SUCCESS,
        ActionTypes.CHANGE_STATUS_POSITION_SUCCESS,
    )]: (state, {payload: statusesInUseIds}) => ({
        ...state,
        loading: false,
        errors: [],
        statusesInUseIds,
    }),
    [combineActions(
        ActionTypes.CREATE_NEW_STATUS_FAILURE,
        ActionTypes.EDIT_STATUS_FAILURE,
        ActionTypes.DELETE_STATUS_FAILURE,
        ActionTypes.CHANGE_STATUS_POSITION_FAILURE,
    )]: (state, {payload: data}) => ({
        ...state,
        loading: false,
        errors: data.errors,
        statusesInUseIds: data.statusesInUseIds,
    }),
    [ActionTypes.SET_ERRORS]: (state, {payload: errors}) => ({
        ...state,
        errors,
    }),

    [ActionTypes.START_EDIT_STATUS]: (state, {payload: editingStatus}) => ({
        ...state,
        editingStatus,
        errors: [],
    }),
    [ActionTypes.CANCEL_EDIT_OR_CREATE_STATUS]: (state) => ({
        ...state,
        editingStatus: {
            id: null,
            name: '',
            type: '',
            position: -1,
            colorId: DEFAULT_COLOR_ID
        },
    }),
    [ActionTypes.START_CREATE_STATUS]: (state, {payload: type}) => ({
        ...state,
        editingStatus: {
            id: NEW_STATUS_ID,
            type,
            name: '',
            colorId: NEW_STATUS_COLOR_ID,
            errors: {}
        },
        errors: [],
    }),
    [ActionTypes.UPDATE_EDITING_STATUS]: (state, {payload: newPart}) => ({
        ...state,
        editingStatus: {
            ...state.editingStatus,
            ...newPart,
        }
    }),
    [ActionTypes.TOGGLE_DIALOG_VISIBILITY]: (state, {payload: show}) => ({
        ...state,
        showEditStatusDialog: show,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/reducer.js